import { TextFieldFormsy } from '@fuse/core/formsy';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Formsy from 'formsy-react';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import EmailIcon from '@material-ui/icons/Email';
import axios from 'axios';
import * as API from 'app/constants/ApiConstants';
import * as APP from 'app/constants/AppConstants';
import { ToastContainer, toast } from 'react-toastify';
import './login.css';

/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
const RECRUITER_STORAGE_KEYS = [
	'Role', 'Name', 'UserName', 'userPhoneNumber', 'Page', 'buid', 'Write',
	'access_token', 'id_token', 'expires_at', 'activatedBUs', 'businessSearchContent', 'vendors', 'Data'
];

function clearRecruiterSession() {
	RECRUITER_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
}

function PartnerLoginTab({ onShowSignup }) {
	const [isFormValid, setIsFormValid] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const formRef = useRef(null);
	const history = useHistory();
	const [values, setValues] = useState({
		email: '',
		password: '',
		showPassword: false
	});

	function disableButton() {
		setIsFormValid(false);
	}

	function enableButton() {
		setIsFormValid(true);
	}

	function handleSubmit(model) {
		if (!values.password || !values.password.trim()) {
			toast('Password is required', { position: toast.POSITION.TOP_CENTER, className: 'foo-bar' });
			return;
		}

		const data = {
			email: model.email,
			password: values.password
		};
		setIsSubmitting(true);
		axios.post(API.PARTNER_AUTH_URL, data)
			.then(response => {
				if (response.status === APP.SUCCESS && response.data && response.data.token) {
					clearRecruiterSession();
					localStorage.setItem('userType', 'partner');
					localStorage.setItem('partnerEmail', response.data.email);
					localStorage.setItem('partnerName', response.data.name);
					localStorage.setItem('partnerBusinessId', response.data.businessId);
					localStorage.setItem('partnerCountry', response.data.country);
					localStorage.setItem('partnerPhone', response.data.phone || '');
					localStorage.setItem('partnerCity', response.data.city || '');
					localStorage.setItem('partnerState', response.data.state || '');
					localStorage.setItem('partnerCompanyName', response.data.companyName || '');
					localStorage.setItem('partnerUserId', String(response.data.partnerUserId || ''));
					localStorage.setItem('partnerCompanyId', String(response.data.partnerCompanyId || ''));
					localStorage.setItem('bearer_token', response.data.token);
					axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
					history.replace('/partner/jobs');
					return;
				}
				toast('Login failed. Invalid response from server.', { position: toast.POSITION.TOP_CENTER, className: 'foo-bar' });
			})
			.catch(error => {
				let message = 'Login failed';
				if (error.response && error.response.data && error.response.data.erroMessage) {
					message = error.response.data.erroMessage;
				} else if (error.message === 'Network Error') {
					message = 'Cannot reach login server. Please try again or contact support.';
				}
				toast(message, { position: toast.POSITION.TOP_CENTER, className: 'foo-bar' });
			})
			.finally(() => {
				setIsSubmitting(false);
			});
	}

	const handleChange = (prop) => (event) => {
		setIsFormValid(true);
		setValues({ ...values, [prop]: event.target.value });
	};

	return (
		<div className="w-full">
			<ToastContainer />
			<Formsy
				onValidSubmit={handleSubmit}
				onValid={enableButton}
				onInvalid={disableButton}
				ref={formRef}
				className="flex flex-col justify-center w-full"
			>
				<TextFieldFormsy
					style={{ width: '81%', marginBottom: '1.6rem !important', padding: '18.5px 14px !important' }}
					className="mb-16"
					type="email"
					name="email"
					label="Partner Email"
					validations={{ minLength: 4 }}
					validationErrors={{ minLength: 'Min character length is 4' }}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<EmailIcon color="action" />
							</InputAdornment>
						)
					}}
					variant="outlined"
					required
				/>

				<FormControl variant="outlined" style={{ marginTop: '10px' }}>
					<InputLabel htmlFor="partner-password">Password*</InputLabel>
					<OutlinedInput
						id="partner-password"
						type={values.showPassword ? 'text' : 'password'}
						value={values.password}
						onChange={handleChange('password')}
						endAdornment={
							<InputAdornment position="end">
								<IconButton
									aria-label="toggle password visibility"
									onClick={() => setValues({ ...values, showPassword: !values.showPassword })}
									edge="end"
									style={{ padding: '7px' }}
								>
									{values.showPassword ? <Visibility /> : <VisibilityOff />}
								</IconButton>
							</InputAdornment>
						}
						labelWidth={70}
					/>
				</FormControl>

				<Button
					type="submit"
					variant="contained"
					color="primary"
					className="w-full mx-auto normal-case mt-16"
					disabled={!isFormValid || isSubmitting}
				>
					{isSubmitting ? 'Logging in...' : 'Log in'}
				</Button>
			</Formsy>
			<div style={{ marginTop: '12px', textAlign: 'center' }}>
				<span className="font-medium">Don&apos;t have an account? </span>
				<button
					type="button"
					className="font-medium"
					onClick={onShowSignup}
					style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3E4EA1', padding: 0 }}
				>
					Sign up
				</button>
			</div>
		</div>
	);
}

export default PartnerLoginTab;
/* Code end. Harsha using AI Agent. October 7, 2026 */
